/* eslint-disable max-lines */
// 兰亭M头，顶部导航，侧边栏，搜索
import React from "react";
import styled, { css, createGlobalStyle } from "styled-components";

import { px2rem } from "utils/browser/resizer";
import Constant, { CountryIConPosition, Host } from "utils/headFootConstants";
import getLangKeyValueFun from "utils/lang";
import LangAndCur from "./components/LangAndCur";
import Country from "./components/Country";
import Search from "./components/Search";
import { AssetImageUrl } from "assets/imgUrls";
import {
	getCategories,
	getCartstore,
	getCountries,
	getLanguages,
	getCurrencies,
	getUserProfile,
	GetCountriesResp,
	getUnPaidOrder,
	CountryInfo,
	GetUnPaidOrderResp,
	getInfo,
} from "headFootServices/header/header";
import langGroup from "assets/lang.json";
import { LayoutProps } from "utils/interface";
import { Color } from "config/index";

const gettext = getLangKeyValueFun(langGroup);
// 侧边栏弹出时，body不滚动
const GlobalStyle = createGlobalStyle`
	body.litb-m-fixscroll {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
	}
`;

const LitbMHeader = styled.div`
	> div {
		z-index: 3000;
	}
`;
const HeaderLayout = styled.section`
	height: ${px2rem(55)};
	border-top: 1px solid #eee;
	border-bottom: 1px solid #e2e2e2;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 ${px2rem(12)} 0 ${px2rem(2.4)};
`;
const HeaderSide = styled.section`
	width: ${px2rem(63)};
	height: ${px2rem(55)};
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
const HeaderIcon = styled.div`
	width: ${px2rem(30)};
	height: ${px2rem(55)};
	display: flex;
	align-items: center;
	justify-content: center;
	> img {
		width: ${px2rem(24)};
		height: ${px2rem(24)};
	}
`;
const CartIcon = styled(HeaderIcon)`
	position: relative;
`;
const Badge = styled.div`
	position: absolute;
	top: 0.375rem;
	right: -0.375rem;
	display: block;
	z-index: 10;
	background: ${Color.Main};
	color: #fff;
	min-width: ${px2rem(16)};
	height: ${px2rem(16)};
	text-align: center;
	line-height: ${px2rem(16)};
	padding: 0;
	font-size: ${px2rem(12)};
	font-weight: 400;
	border-radius: ${px2rem(8)};
	span {
		padding: 0 4px;
	}
`;
const Title = styled.a`
	width: ${px2rem(160)};
	height: 100%;
	position: relative;
	> img {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
`;
const Cover = styled.div`
	position: fixed;
	top: 0;
	width: 100vw;
	height: 100%;
	opacity: 0;
	pointer-events: none;
	transition: opacity 0.4s ease;
	background: rgba(0, 0, 0, 0.6);
	> img {
		position: absolute;
		top: ${px2rem(15)};
		right: ${px2rem(50)};
		width: ${px2rem(24)};
		height: ${px2rem(24)};
	}
	${(props: { show: boolean }) =>
		props.show &&
		css`
			opacity: 1;
			pointer-events: auto;
		`};
`;
const Side = styled.div`
	position: fixed;
	top: 0;
	left: -100vw;
	height: 100%;
	width: 77.3333333333vw;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	background: #f5f5f5;
	transition: transform 0.4s ease;
	font-size: ${px2rem(14)};
	font-weight: normal;
	color: #333333;
	box-sizing: content-box;

	@supports (bottom: constant(safe-area-inset-bottom)) {
		padding-bottom: constant(safe-area-inset-bottom);
	}

	@supports (bottom: env(safe-area-inset-bottom)) {
		padding-bottom: env(safe-area-inset-bottom);
	}
	${(props: { show: boolean }) =>
		props.show &&
		css`
			transform: translate3d(100vw, 0, 0);
		`};
`;
const SideItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: #fff;
`;
const NextIcon = styled.img`
	width: ${px2rem(16)};
	height: ${px2rem(16)};
	${(props: { deg: number }) =>
		css`
			transform: rotate(${props.deg}deg);
		`};
`;
const LogInfo = styled.span`
	font-size: ${px2rem(16)};
	font-weight: 500;
	color: #333333;
`;
const LogSideItem = styled(SideItem)`
	height: ${px2rem(48)};
	border-bottom: 1px solid #f2f2f2;
	padding: 0 ${px2rem(12)};
	box-sizing: border-box;
`;
const MySideItem = styled(SideItem)`
	height: ${px2rem(48)};
	padding: 0 ${px2rem(12)};

	> * {
		&:first-child {
			flex: 1;
		}
	}
`;
const MyLeft = styled.div`
	display: flex;
	align-items: center;
	> img {
		width: ${px2rem(24)};
		height: ${px2rem(24)};
		margin-right: ${px2rem(9)};
	}
`;

const MyDot = styled.div`
	flex: 1;
	display: flex;
	justify-content: flex-end;
`;
const CategoryList = styled.div`
	margin-top: ${px2rem(9)};
	padding-bottom: ${px2rem(9)};
	background: #fff;
`;
const CategorySideItem = styled(SideItem)`
	height: ${px2rem(44)};
	box-sizing: content-box;
	padding: ${px2rem(15)} ${px2rem(12)} 0;
`;
const CategoryLeft = styled.div`
	height: 100%;
	display: flex;
	align-items: center;
`;
const GreyBg = styled.div`
	width: ${px2rem(44)};
	height: ${px2rem(44)};
	position: relative;
	margin-right: ${px2rem(6)};
	> img {
		width: 100%;
		height: 100%;
		border-radius: 50%;
	}
	> div {
		position: absolute;
		top: 0;
		left: 0;
		background: #000;
		opacity: 0.03;
		width: 100%;
		height: 100%;
		border-radius: 50%;
	}
`;
const SettingSideItem = styled(SideItem)`
	height: ${px2rem(48)};
	border-bottom: 1px solid #f2f2f2;
	margin: 0 ${px2rem(12)};

	> * {
		&:first-child {
			flex: 1;
		}
	}
`;
const SettingLeft = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	> span:last-child {
		margin-right: ${px2rem(5)};
	}
`;
const SettingSide = styled.div`
	margin-top: ${px2rem(9)};
	background: #fff;
	${SettingSideItem}:last-child {
		border-bottom: none;
	}
	&:last-child {
		margin-bottom: 50px;
	}
`;
const CountryIcon = styled.span`
	display: inline-block;
	width: ${px2rem(24)};
	height: ${px2rem(16)};
	background-image: url(https://lijc.rightinthebox.com/jupiter_lightsource/img/icon_header_country_flag.png);
	background-repeat: no-repeat;
	background-position: 100px 100px;
`;
const SideBody = styled.section`
	flex: auto 1;
`;

const SideBottomIcon = styled.div`
	height: ${px2rem(50)};
	flex: ${px2rem(50)} 0 0;
	width: 100%;
	padding: 0 ${px2rem(15)};
	display: flex;
	justify-content: space-between;
	border-top: 1px solid #eee;
	background-color: #fff;
	box-sizing: border-box;
	> div {
		width: ${px2rem(30)};
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
	}
`;

const LittleRedDot = styled.span`
	width: 9px;
	height: 9px;
	background: #ed3d28;
	border-radius: 100%;
`;

interface HeaderState {
	userName: string;
	total_results: number;
	showSidebar: boolean;
	showSearchModal: boolean;
	showCountryModal: boolean;
	showCurrencyModal: boolean;
	countries: CountryInfo[];
	topCountries: CountryInfo[];
	currentCountry: CountryInfo;
	categories: any[];
	userCurrency: any;
	currencies: any[];
	showLanguageModal: boolean;
	userLanguage: any;
	languages: any[];
	hasUnPaidOrder: boolean;
	/** 低价APP 折扣应用国家国际化文案 */
	lowPriceCountryPriceOff: string;
}

class Header extends React.Component<LayoutProps, HeaderState> {
	constructor(props) {
		super(props);
		this.state = {
			userName: "",
			total_results: 0,
			showSidebar: false,
			showSearchModal: false,
			showCountryModal: false,
			countries: [],
			topCountries: [],
			currentCountry: null,
			showCurrencyModal: false,
			userCurrency: {},
			currencies: [],
			showLanguageModal: false,
			userLanguage: {
				language_code: Constant.language || "en",
				language_name: "",
			},
			languages: [],
			categories: [],
			hasUnPaidOrder: false,
			lowPriceCountryPriceOff: "",
		};
	}

	componentDidMount() {
		if (Constant.isLogin) {
			this.getUser();
		}
		this.getAppLowpriceCountry();
		this.getCart();
		this.getCate();
		this.getCountry();
		this.getLanguage();
		this.getCurrency();
		this.getUnPaidOrder();
	}
	// 获取用户信息
	getUser = () => {
		getUserProfile(
			{ sessionkey: Constant.sessionKey ? Constant.sessionKey : undefined },
			{ onSentryCatch: this.props.onSentryCatch },
		)
			.then((res: any) => {
				const { user = 0 } = res.info || {};
				const userName = user.email ? user.email.split("@")[0] : user.user_id;
				this.setState({ userName });
			})
			.catch((err) => {
				console.log(err);
			});
	};
	// 获取未支付订单
	getUnPaidOrder = () => {
		getUnPaidOrder(
			{ sessionkey: Constant.sessionKey ? Constant.sessionKey : undefined },
			{ onSentryCatch: this.props.onSentryCatch },
		).then((res: GetUnPaidOrderResp) => {
			if (res) {
				this.setState({ hasUnPaidOrder: !!res?.info?.total_results });
			}
		});
	};
	// 获取购物车数量
	getCart = () => {
		getCartstore(
			{
				sessionkey: Constant.sessionKey ? Constant.sessionKey : undefined,
			},
			{ onSentryCatch: this.props.onSentryCatch },
		)
			.then((res: any) => {
				const { total_results = 0 } = res.info || [];
				this.setState({ total_results });
			})
			.catch((err) => {
				console.log(err);
			});
	};
	// 获取类目
	getCate = () => {
		getCategories(
			{ feature_category_header: "YES" },
			{ onSentryCatch: this.props.onSentryCatch },
		)
			.then((res: any) => {
				const categories = res.info || [];
				this.setState({ categories });
			})
			.catch((err) => {
				console.log(err);
			});
	};
	// 获取country
	getCountry = () => {
		getCountries(null, { onSentryCatch: this.props.onSentryCatch })
			.then((res: GetCountriesResp) => {
				const { countries = [], topCountries = [] } = res.info || {};
				const currentCountry = countries.find(
					(item) => item.countryIsoCode3 === Constant.country,
				);
				this.setState({
					countries,
					topCountries,
					currentCountry,
				});
			})
			.catch((err) => {
				console.log(err);
			});
	};
	// 获取language
	getLanguage = () => {
		getLanguages(null, { onSentryCatch: this.props.onSentryCatch })
			.then((res: any) => {
				const { languages = [] } = res.info || [];
				const userLanguage = languages.find(
					(item) => item.language_code === Constant.language,
				) || {
					language_code: "en",
					language_name: "English",
				};
				this.setState({
					userLanguage,
					languages,
				});
			})
			.catch((err) => {
				console.log(err);
			});
	};
	// 获取currency
	getCurrency = () => {
		getCurrencies(null, { onSentryCatch: this.props.onSentryCatch })
			.then((res: any) => {
				const { currencies = [], new_currencies = [] } = res.info || {};
				let currencyList = [];
				if (new_currencies && new_currencies.length > 0) {
					currencyList = new_currencies;
				} else {
					currencyList = currencies;
				}
				const userCurrency =
					currencyList.find((item) => item.currency_code === Constant.currency) || {};
				this.setState({
					userCurrency,
					currencies: currencyList,
				});
			})
			.catch((err) => {
				console.log(err);
			});
	};

	// 底价APP规则应用国家列表
	getAppLowpriceCountry = () => {
		const ATTRNAME_KEY = "APP_LOWPRICE_COUNTRY";
		getInfo(
			{ namespace: "LITB.OTHER.COUNTRIES", attrName: ATTRNAME_KEY },
			{ onSentryCatch: this.props.onSentryCatch },
		)
			.then((res: any) => {
				const { value = {} } = res.info || {};
				const keyValue: string = value[ATTRNAME_KEY] || "";
				if ((keyValue as string).split(",").includes(Constant.countryId)) {
					this.getAppLowPriceTextContent();
				}
			})
			.catch((err) => {
				console.warn(err);
			});
	};

	// 获取导流国际化文案
	getAppLowPriceTextContent = () => {
		const ATTRNAME_KEY = "app_show_banner_B_new";
		getInfo(
			{
				namespace: "LITB.APP.SERVER_B",
				attrName: ATTRNAME_KEY,
				nsLanguageCode: Constant.language,
			},
			{ onSentryCatch: this.props.onSentryCatch },
		)
			.then((res: any) => {
				const { value = {} } = res.info || {};
				this.setState({ lowPriceCountryPriceOff: value[ATTRNAME_KEY] || "" });
			})
			.catch((err) => {
				console.warn(err);
			});
	};

	openSidebar = () => {
		document.body.classList.add("litb-m-fixscroll");
		this.setState({ showSidebar: true });
	};

	closeSidebar = () => {
		document.body.classList.remove("litb-m-fixscroll");
		this.setState({ showSidebar: false });
	};

	needLogin = (path: string) => {
		const BaseUrl = Host[String(Constant.isUat)];
		console.log("Constant.sessionKey++++++++++++++", Constant.sessionKey, this.state.userName);
		if (Constant.sessionKey && this.state.userName) {
			this.goPage(path);
			return;
		}
		window.location.href = `${BaseUrl.gmHost}/signin`;
	};

	stateChange = <T extends keyof HeaderState>(type: T, value: HeaderState[T]) => {
		this.setState({ [type]: value } as Pick<HeaderState, T>);
	};

	goPage = (path: string) => {
		window.location.href = path;
	};

	render() {
		const {
			userName,
			total_results,
			showSidebar,
			categories,
			userCurrency,
			countries,
			topCountries,
			currentCountry,
			currencies,
			userLanguage,
			languages,
			showSearchModal,
			showCountryModal,
			showCurrencyModal,
			showLanguageModal,
		} = this.state;

		const BaseUrl = Host[String(Constant.isUat)];
		return (
			<LitbMHeader>
				<GlobalStyle />
				<HeaderLayout>
					<HeaderSide>
						<HeaderIcon onClick={() => history.back()}>
							<img src={AssetImageUrl["ic_back@3x.png"]} alt="back" />
						</HeaderIcon>
						<HeaderIcon onClick={this.openSidebar}>
							<img src={AssetImageUrl["ic_menu@3x.png"]} alt="menu" />
						</HeaderIcon>
					</HeaderSide>
					<Title href="/">
						<img
							src={AssetImageUrl.m_head_logo}
							style={{ height: px2rem(30) }}
							alt="eechic"
						/>
					</Title>
					<HeaderSide>
						<HeaderIcon onClick={() => this.setState({ showSearchModal: true })}>
							<img
								src={AssetImageUrl["ic_search@3x.png"]}
								alt="search"
								style={{ width: px2rem(24), height: px2rem(24) }}
							/>
						</HeaderIcon>
						<CartIcon
							onClick={() =>
								this.goPage(`${BaseUrl.gmHost}/${userLanguage.language_code}/cart`)
							}
						>
							<img
								src={AssetImageUrl["tabbar_ic_cart@3x.png"]}
								alt="cart"
								style={{ width: px2rem(24), height: px2rem(24) }}
							/>
							{total_results ? (
								<Badge>
									<span>{total_results > 999 ? "999+" : total_results}</span>
								</Badge>
							) : null}
						</CartIcon>
					</HeaderSide>
				</HeaderLayout>
				{/* sidebar */}
				<Cover show={showSidebar}>
					<img
						src={AssetImageUrl["ic_closed@3x.png"]}
						onClick={this.closeSidebar}
						alt="closed"
					/>
				</Cover>
				<Side show={showSidebar}>
					<SideBody style={{ overflow: "auto" }}>
						<div>
							<LogSideItem
								onClick={() =>
									this.needLogin(
										`${BaseUrl.gmHost}/${userLanguage.language_code}/account`,
									)
								}
							>
								{Constant.isLogin && userName ? (
									<LogInfo>
										{gettext("Hi,")} {userName}
									</LogInfo>
								) : (
									<LogInfo>
										{gettext("Hi,")} {gettext("Sign In or Register")}
									</LogInfo>
								)}
								<NextIcon
									src={AssetImageUrl["ic_next@3x.png"]}
									deg={0}
									alt="Sign In or Register"
								/>
							</LogSideItem>
							<MySideItem
								onClick={() =>
									this.needLogin(
										`${BaseUrl.gmHost}/${userLanguage.language_code}/account`,
									)
								}
							>
								<MyLeft>
									<img
										src={AssetImageUrl["ic_My Account1@3x.png"]}
										alt="My Account"
									/>
									<span>{gettext("My Account")}</span>
								</MyLeft>
								<NextIcon
									src={AssetImageUrl["ic_next@3x.png"]}
									deg={0}
									alt="My Account"
								/>
							</MySideItem>
							<MySideItem
								onClick={() =>
									this.needLogin(
										`${BaseUrl.gmHost}/${userLanguage.language_code}/orders`,
									)
								}
							>
								<MyLeft>
									<img
										src={AssetImageUrl["ic_My Orders@3x.png"]}
										alt="My Orders"
									/>
									<span>{gettext("My Orders")}</span>
									{this.state.hasUnPaidOrder && (
										<MyDot>
											<LittleRedDot />
										</MyDot>
									)}
								</MyLeft>
								<NextIcon
									src={AssetImageUrl["ic_next@3x.png"]}
									deg={0}
									alt="My Orders"
								/>
							</MySideItem>
							<MySideItem
								onClick={() =>
									this.needLogin(
										`${BaseUrl.gmHost}/${userLanguage.language_code}/favorites`,
									)
								}
							>
								<MyLeft>
									<img
										src={AssetImageUrl["ic_My Favorites@3x.png"]}
										alt="My Favorites"
									/>
									<span>{gettext("My Favorites")}</span>
								</MyLeft>
								<NextIcon
									src={AssetImageUrl["ic_next@3x.png"]}
									deg={0}
									alt="My Favorites"
								/>
							</MySideItem>
							<MySideItem
								onClick={() =>
									this.needLogin(
										`${BaseUrl.gmHost}/${userLanguage.language_code}/e/help_center`,
									)
								}
							>
								<MyLeft>
									<img
										src={AssetImageUrl["ic_Help Center1@3x.png"]}
										alt="Help Center"
									/>
									<span>{gettext("Help Center")}</span>
								</MyLeft>
								<NextIcon
									src={AssetImageUrl["ic_next@3x.png"]}
									deg={0}
									alt="Help Center"
								/>
							</MySideItem>
							{categories && categories.length > 0 ? (
								<CategoryList>
									{categories.map((item, index) => {
										return (
											<CategorySideItem
												key={index}
												onClick={() => this.goPage(`${item.link_url}`)}
											>
												<CategoryLeft>
													<GreyBg>
														{item.category_image_url ? (
															<img
																src={item.category_image_url}
																alt={item.category_name}
															/>
														) : null}
														<div />
													</GreyBg>
													<div>{item.category_name}</div>
												</CategoryLeft>
												<NextIcon
													src={AssetImageUrl["ic_next@3x.png"]}
													deg={0}
													alt={item.category_name}
												/>
											</CategorySideItem>
										);
									})}
								</CategoryList>
							) : null}
							<SettingSide>
								<SettingSideItem>
									<SettingLeft
										onClick={() =>
											this.setState({
												showCountryModal: true,
											})
										}
									>
										<span>{gettext("Ship to")}</span>
										<CountryIcon
											style={{
												backgroundPosition:
													CountryIConPosition[
														currentCountry?.countryIsoCode2
													],
											}}
										/>
									</SettingLeft>
									<NextIcon
										src={AssetImageUrl["ic_next@3x.png"]}
										deg={0}
										alt="Ship to"
									/>
								</SettingSideItem>
								<SettingSideItem
									onClick={() =>
										this.setState({
											showLanguageModal: true,
										})
									}
								>
									<SettingLeft>
										<span>{gettext("Language")}</span>
										<span style={{ color: "#888" }}>
											{userLanguage.language_text}
										</span>
									</SettingLeft>
									<NextIcon
										src={AssetImageUrl["ic_next@3x.png"]}
										deg={0}
										alt="Language"
									/>
								</SettingSideItem>
								<SettingSideItem
									onClick={() =>
										this.setState({
											showCurrencyModal: true,
										})
									}
								>
									<SettingLeft>
										<span>{gettext("Currency")}</span>
										<span style={{ color: "#888" }}>
											{userCurrency.currency_symbol}&nbsp;
											{userCurrency.currency_code}
										</span>
									</SettingLeft>
									<NextIcon
										src={AssetImageUrl["ic_next@3x.png"]}
										deg={0}
										alt="Currency"
									/>
								</SettingSideItem>
							</SettingSide>
							<SettingSide>
								<SettingSideItem
									onClick={() =>
										this.goPage(
											`${BaseUrl.gmHost}/${userLanguage.language_code}/about`,
										)
									}
								>
									<span>{gettext("About Us")}</span>
									<NextIcon
										src={AssetImageUrl["ic_next@3x.png"]}
										deg={0}
										alt="About Us"
									/>
								</SettingSideItem>
							</SettingSide>
						</div>
					</SideBody>
					<SideBottomIcon>
						<div
							onClick={() =>
								this.goPage(`${BaseUrl.mHost}/${userLanguage.language_code}`)
							}
						>
							<img
								src={AssetImageUrl["tabbar_ic_home@3x.png"]}
								width="24px"
								height="24px"
								alt="home"
							/>
						</div>
						<div
							onClick={() =>
								this.needLogin(
									`${BaseUrl.gmHost}/${userLanguage.language_code}/e/help_center`,
								)
							}
						>
							<img
								src={AssetImageUrl["tabbar_ic_center@3x.png"]}
								width="24px"
								height="24px"
								alt="help center"
							/>
						</div>
						<div
							onClick={() =>
								this.goPage(`${BaseUrl.gmHost}/${userLanguage.language_code}/cart`)
							}
						>
							<img
								src={AssetImageUrl["tabbar_ic_cart@3x.png"]}
								width="24px"
								height="24px"
								alt="cart"
							/>
							{total_results ? (
								<Badge>
									<span>{total_results}</span>
								</Badge>
							) : null}
						</div>
						<div
							onClick={() =>
								this.needLogin(
									`${BaseUrl.gmHost}/${userLanguage.language_code}/account`,
								)
							}
						>
							<img
								src={AssetImageUrl["tabbar_ic_account@3x.png"]}
								width="24px"
								height="24px"
								alt="account"
							/>
						</div>
					</SideBottomIcon>
				</Side>
				{showSearchModal ? (
					<Search
						stateChange={this.stateChange}
						onSentryCatch={this.props.onSentryCatch}
					/>
				) : null}
				{showCountryModal && (
					<Country
						countries={countries}
						popularCountries={topCountries}
						currentCountry={currentCountry}
						stateChange={this.stateChange}
					/>
				)}

				{showCurrencyModal ? (
					<LangAndCur list={currencies} title="Currency" stateChange={this.stateChange} />
				) : null}
				{showLanguageModal ? (
					<LangAndCur
						list={languages}
						title="Language"
						stateChange={this.stateChange}
						onChangeLanguage={this.props.onChangeLanguage}
					/>
				) : null}
			</LitbMHeader>
		);
	}
}

export default Header;
